module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAA3ElEQVRIS2NkIBVcXcXG8OFLNwMDYwwDAwMjA8P/xQwCPKUM2mG/SDGKkRTFYLVH509gYGDIR9PXyWCdWEGKWeRY/JaBgUEIzZJ3DNaJwrS2+D9WC6wTSfIESYqhQT1qMSTkR4MalgJx5HvaJy4c+Z4eFmPN9/SwGGv2Y2Qgtew9Op+0fIxDPSPJZS8VLSat7KWixVQJOpwFCJ6gHrUYf9k7GsewMhlX7TSauKAhBCq5RrPT8M9OpFYSVFGPo1r838VgnVSOteGOtSlDunrkhkAsxCICnTBEw4Ei9QBTl+7T0xg+ZgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/fmIcon.png
// module id = cWs/
// module chunks = 1